import { render, staticRenderFns } from "./TenderContactPersonItem.vue?vue&type=template&id=112553d4&scoped=true"
import script from "./TenderContactPersonItem.vue?vue&type=script&lang=js"
export * from "./TenderContactPersonItem.vue?vue&type=script&lang=js"
import style0 from "./TenderContactPersonItem.vue?vue&type=style&index=0&id=112553d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112553d4",
  null
  
)

export default component.exports